import { BaseText } from "@/components/atom/text/BaseText";
import { TextProps } from "@mantine/core";

export const WorkText = ({ ...etcProps }: TextProps) => {
  return <BaseText size={"md"} c={"gray.6"} {...etcProps} />;
};
